module.exports = __webpack_public_path__ + "img/ch07_10_公交站台.0b9c5ee3.jpg";